import type { Empresa } from "@/componentes/empresa/tipos"
import type { Persona } from "@/componentes/personas/persona"

import { CarnetFrente } from "./CarnetFrente"
import { CarnetReverso } from "./CarnetReverso"
import { SEPARACION_CARAS } from "./medidas"

/**
 * Las dos caras del carnet, una al lado de la otra.
 *
 * ⚠ **Es el MISMO componente que se imprime**, igual que en rotulación. `VistaCarnet`
 * pinta la vista previa y el pliego lo repite en hojas. Una previa dibujada aparte es
 * una segunda verdad que se desincroniza al primer ajuste, y en un módulo cuyo único
 * fin es ver antes de gastar una tarjeta plastificada, eso lo anula.
 *
 * ⚠ **Las dos caras van juntas en la misma pieza y se recortan por separado.** Ver la
 * nota de `CarnetReverso`: no se imprimen a dúplex porque una impresora de oficina no
 * registra las dos caras de una tarjeta de 54 mm con la precisión que hace falta, y
 * el desplazamiento sólo se ve cuando ya está plastificada.
 */
export function VistaCarnet({
  persona,
  empresa,
  foto,
  conReverso = true,
}: {
  persona: Persona
  empresa?: Empresa
  foto: string | null
  /** El reverso sólo tiene sentido si la ficha trae contacto de emergencia. */
  conReverso?: boolean
}) {
  return (
    <div style={{ display: "flex", gap: `${SEPARACION_CARAS}mm`, alignItems: "flex-start" }}>
      <CarnetFrente persona={persona} empresa={empresa} foto={foto} />
      {conReverso ? <CarnetReverso persona={persona} empresa={empresa} /> : null}
    </div>
  )
}
